import axios from "axios";

const chipsWebApi = {
  abortController: new AbortController(),

  /**
   * @param options {method, url, data, then, error}
   */
  request: function (options) {
    try {
      options.globalError = this.globalError;

      // eslint-disable-next-line no-undef
      axios({
        method: options.method,
        url: options.url,
        // eslint-disable-next-line no-undef
        headers: options.headers || {
          "Content-Type": "application/json",
        },
        data: options.data,
        signal: this.abortController.signal,
      })
        .then(function (response) {
          if (options.then) {
            options.then(response);
          }
        })
        .catch(function (e) {
          if (!axios.isCancel(e)) {
            options.globalError(e, options);
          }
        });
    } catch (e) {
      options.globalError(e, options);
    }
  },

  globalError: async function (e, options) {
    const data = e.response?.data;
    const code = data?.code || -1;
    if (!options.error || !options.error(e)) {
      const attributes = {
        icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
        title: "알 수 없는 오류",
        body: "이용에 불편 드려 죄송합니다.\n잠시 후 다시 시도해 주세요!",
        secondary_button_text: "확인",
        secondary_button_style: "secondary",
        secondary_button_callback: "chipsApp.close()",
      };

      if (data?.title || data?.message) {
        attributes.title = data.title;
        attributes.body = data.message;
      }
      alert(attributes.body);
    }
  },
};

export default chipsWebApi;
